module.exports = __webpack_public_path__ + "media/Reciclaje.e4c04ddf.mp4";